export default (function () {
  return {
    path: '*',
    status: 404,
    component: require('features/ErrorPages/NotFound').NotFound
  };
});